<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-06 15:33:08
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-20 17:29:10
 * @FilePath: /content-center/src/components/wiki/SymptomsParts.vue
-->
<template>
  <div class="flex align-items-center department-item">
    <div class="content-item-label"><span v-if="JSON.parse(commonData[1].value)==='1'" class="red">*</span>{{JSON.parse(commonData[2].value)||'适用部位'}}</div>
    <el-select multiple v-model="select" placeholder="请选择症状部位" @change="bodyPart">
      <el-option
        v-for="(item,index) in symptomsParts"
        :key="index"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from '@/utils/axios';

export default {
  name: "SymptomsParts",
  props: ['symptomsPartsValue', 'commonData'],
  data() {
    return {
      symptomsParts: []
    }
  },
  created(){
    this.getSymptomsParts()
  },
  computed: {
    select: {
      get() {
        return this.symptomsPartsValue
      },
      set(val) {
        this.$emit('update:symptomsPartsValue',val)
      }
    }
  },
  methods: {
    // 获取症状部位
    async getSymptomsParts() {
      await request('health_cmp_queryBodyParts',{
        tenantId: this.$commonJs.getTenantId(),
      }).then(res => {
        this.symptomsParts = res.data
      })
    },
    // 身体部位需要的得value和label的值
    bodyPart(val) {
      if (val.length > Number(JSON.parse(this.commonData[0].value))) {
        this.$message.error("最多选择5个部位");
      }
      this.select = val.filter((item, index) => {
        return index < 5;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.department-item {
  font-size: 14px;
  color: #2c3443;
  margin-top: 20px;
  position: relative;
  width: 50%;

  .content-item-label {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;

    span {
      color: #f62458;
      margin-right: 5px;
    }
  }
}
</style>
